import { render, staticRenderFns } from "./ErrorPermissions.vue?vue&type=template&id=49fedc2a&scoped=true"
import script from "./ErrorPermissions.vue?vue&type=script&lang=js"
export * from "./ErrorPermissions.vue?vue&type=script&lang=js"
import style0 from "./ErrorPermissions.vue?vue&type=style&index=0&id=49fedc2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49fedc2a",
  null
  
)

export default component.exports